<template>
  <v-flex :class="input.mandatory === 'yes' && input.continued === 'yes' ? // if mandatory + continued attr
                  'question-inputs pb-0 pt-7' : input.mandatory === 'yes' ? // if mandatory
                  'question-inputs py-5 pt-7' : input.continued ? // if continued attr
                  'question-inputs pb-3 pt-5' : input.padding ? // if padding attr
                  'question-inputs pb-5 pt-0' : 'question-inputs py-5'">

    <HTTPresponse :alert="httpalert" @changeHTTPBoxState="HTTPState"></HTTPresponse>

    <v-textarea
      v-model="value"
      @change="onChange"
      outlined
      hide-details
      :label="unescaped(input[`label_${$i18n.locale}`])"
      clear-icon="icon-delete delete-icon"
      clearable
      @click:clear="deleteText"
      :required="input.mandatory === 'yes' ? 'required' : false"
      :aria-required="input.mandatory === 'yes' ? 'required' : false"
    ></v-textarea>
    <small
      v-if="input.mandatory === 'yes'"
      v-html="`(${$t('inputs.mandatory')})`"
      class="mandatory-label"
    ></small>
    <small
      v-if="input[`text_${$i18n.locale}`]"
      class="mt-2 mb-0 pl-8 d-block"
    ><pre v-html="input[`text_${$i18n.locale}`]"></pre></small>
    <!-- <div v-if="input.mandatory === 'yes'" class="mt-3 pl-7">
      <v-checkbox
        v-model="derogation"
        hide-details
        :label="$t('inputs.exemption')"
        @change="checkDerogation"
      ></v-checkbox>
      <div class="mb-5"></div>
      <v-textarea
        v-if="openDerogation"
        v-model="textDerogation"
        @change="onDeragation"
        outlined
        hide-details
        :label="$t('inputs.exemption-label')"
        clear-icon="icon-delete delete-icon"
        clearable
        required
        aria-required="true"
        :rules="[rules.required]"
      ></v-textarea>
    </div> -->
  </v-flex>
</template>

<script>
/* eslint-disable */
import { delegateRecord } from '@/js/delegate/delegateRecord'
import HTTPresponse from '@/components/app/HTTPresponse'
// import { recordDerogation } from '@/js/survey/recordDerogation'

export default {
  props: {
    input: Object|Array,
    collaboratorid: String,
    collaborationkey: String,
    answerid: String,
    path: String
  },
  components: {
    HTTPresponse: HTTPresponse
  },

  data () {
    return {
      value: this.input.answer ? this.input.answer : '',
      httpalert: false
      // derogation: this.input.derogation ? true : false,
      // openDerogation: this.input.derogation ? true : false,
      // textDerogation: this.input.derogation ? this.input.derogation : '',

      // rules: {
      //   required: value => !!value || 'Required.'
      // }
    }
  },

  methods: {
    onChange () {
      // if (!this.$store.getters['auth/isAuthenticated']) return
      // call API to record an answer
      const params = {
        method: 'get',
        option: this.value === '' || this.value === undefined || this.value === null ? 'delete' : 'json',
        answerid: this.answerid,
        collaboratorid: this.collaboratorid,
        collaborationkey: this.collaborationkey,
        moduleid: this.input.id,
        path: `${this.path}|${this.input.id}`,
        value: this.value
      }
      delegateRecord(params)
        .then(() => this.$emit('inputUpdate'))
        .catch(() => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })
    },

    // onDeragation () {
    //   if (!this.$store.getters['auth/isAuthenticated']) return
    //   // call API to record an answer
    //   const params = {
    //     option: this.derogation == '' || this.derogation == undefined ||
    //            this.derogation == null || this.derogation == false ||
    //            this.textDerogation == '' || this.textDerogation == undefined ||
    //            this.textDerogation == null || this.textDerogation == false ? 'delete' : 'json',
    //     answerid: this.answerid,
    //     moduleid: this.input.id,
    //     path: `${this.path}|${this.input.id}`,
    //     value: (this.derogation == '' || this.derogation == undefined ||
    //            this.derogation == null || this.derogation == false) &&
    //            (this.textDerogation == '' || this.textDerogation == undefined ||
    //            this.textDerogation == null || this.textDerogation == false) ? '' : this.textDerogation,
    //     key: this.$store.state.auth.token
    //   }
    //   recordDerogation(params)
    //     .then(response => this.$emit('inputUpdate'))
    //     .catch(error => console.log(error))
    // },

    // checkDerogation () {
    //   this.openDerogation = !this.openDerogation
    //   if (this.openDerogation == false) {
    //     this.textDerogation = ''
    //     this.onDeragation()
    //   }
    // },

    deleteText () {
      const params = {
        method: 'get',
        option: 'delete',
        answerid: this.answerid,
        collaboratorid: this.collaboratorid,
        collaborationkey: this.collaborationkey,
        moduleid: this.input.id,
        path: `${this.path}|${this.input.id}`,
        value: this.value
      }
      delegateRecord(params)
        .then(response => this.$emit('inputUpdate'))
        .catch(() => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })
    },

    unescaped (string) {
      var txt = document.createElement('textarea')
      txt.innerHTML = string
      return txt.value
    },

    HTTPState (value) {
      this.httpalert = this.value
    }
  }
}
</script>
